import { watch } from 'vue'
import { useDisplay } from 'vuetify'

import { useNavigationVisibilityStore } from '@/store/NavigationVisibilityStore'
import { mobileBreakpointValue } from '@/util/util'

export const useResizeObserverNavigationVisibility = () => {
  const navigationVisibilityStore = useNavigationVisibilityStore()
  const { width } = useDisplay()

  watch(width, (previousWidth, nextWidth) => {
    const resizingFromDesktopToMobile = previousWidth < nextWidth
    const resizingFromMobileToDesktop = previousWidth > nextWidth
    const matchingMobileBreakpoint =
      Math.abs(mobileBreakpointValue - width.value) < 20
    if (matchingMobileBreakpoint && resizingFromDesktopToMobile)
      navigationVisibilityStore.hideSidebars()

    if (matchingMobileBreakpoint && resizingFromMobileToDesktop)
      navigationVisibilityStore.openSidebars()
  })
}
